/**
 * Put an autopilot response where a developer can actually read it.
 *
 * These payloads are the unit of work when tuning the import: a prompt change
 * is judged by reading one against the last. The network panel was the only
 * place they existed, and it evicts response bodies without warning — "Request
 * with the provided ID has already finished loading" is a two-minute run thrown
 * away with nothing to recover.
 *
 * Gated on MODE rather than DEV, which is not the same thing here: this app is
 * served in development both by the Vite dev server and by an auto-built bundle
 * (config/vite.json, publicOutputDir "vite-dev"), and `vite build --mode
 * development` leaves DEV false — so a DEV guard is dead in half the ways the
 * app actually runs locally. MODE is 'development' for both and 'production'
 * only for the real build.
 *
 * Either way it is a compile-time constant, so the block is removed from the
 * production bundle rather than merely staying quiet in it. That matters here
 * specifically: LogRocket is loaded in the application layout and records
 * console output to a third party, so logging this payload would ship a
 * client's lease and their counterparty's letter of intent off the machine. It
 * cannot be left to a runtime flag someone might set.
 */
export function logAutopilotPayload(tag, payload) {
  if (import.meta.env.MODE === 'production') return;

  // Logged as an object rather than a string: the console truncates long
  // strings, and an object can be expanded, and right-click → Copy object gives
  // the whole thing as JSON.
  console.log(`[autopilot] ${tag}`, payload);

  // Kept on `window` as well, so the console can reach the last one at any
  // time: `copy(autopilot.proposals)` puts the full payload on the clipboard,
  // which the network panel never managed reliably.
  window.autopilot = window.autopilot || {};
  window.autopilot[tag] = payload;
}
